import { trackRetailerMarketingBuilderLandingPageSignupModalOpenClick } from "@faire/web-api--source/events/retailerMarketing/click/builderLandingPageSignupModalOpen";
import { trackSignupOpenFdProductSignUpModalClick } from "@faire/web-api--source/events/signup/click/openFdProductSignUpModal";
import { trackSignupOpenFdSignUpModalClick } from "@faire/web-api--source/events/signup/click/openFdSignUpModal";
import { trackSignupOpenProductSignUpModalClick } from "@faire/web-api--source/events/signup/click/openProductSignUpModal";
import { trackSignupOpenSignUpModalClick } from "@faire/web-api--source/events/signup/click/openSignUpModal";
import {
  route as productPageRoute,
  PathParameters as ProductPathParameters,
} from "@faire/web-api--source/routes/www/product/productToken";
import { matchPath } from "react-router-dom";

export const trackFDSignupModal = (pathname: string) => {
  const match = matchPath<ProductPathParameters>(pathname, {
    path: productPageRoute,
  });
  const productToken = match?.params?.productToken;

  if (productToken) {
    trackSignupOpenFdProductSignUpModalClick(productToken);
  } else {
    trackSignupOpenFdSignUpModalClick();
  }
};

export const trackSignupModal = (productToken?: string, pathname?: string) => {
  trackRetailerMarketingBuilderLandingPageSignupModalOpenClick(pathname ?? "");

  if (productToken) {
    trackSignupOpenProductSignUpModalClick(productToken);
  } else {
    trackSignupOpenSignUpModalClick();
  }
};
